goog.provide("shadow.js.shim.module$src$svg$objects$3d_cube_svg$default");
shadow.js.shim.module$src$svg$objects$3d_cube_svg$default = shadow.js.shim.module$src$svg$objects$3d_cube_svg.default;
